const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://admin.goridesrw.com/api/remote';
const PUBLIC_UPLOADS_BASE_URL = API_BASE_URL.replace(/\/api\/remote$/, '');

export const buildPublicFileUrl = (filePath) => {
  if (!filePath) return '';
  if (filePath.startsWith('http')) return filePath;
  if (filePath.startsWith('/uploads/')) return `${PUBLIC_UPLOADS_BASE_URL}${filePath}`;
  if (filePath.startsWith('/')) return `${PUBLIC_UPLOADS_BASE_URL}/uploads${filePath}`;
  return `${PUBLIC_UPLOADS_BASE_URL}/uploads/${filePath}`;
};

export const publicUploadsBaseUrl = PUBLIC_UPLOADS_BASE_URL;
